import { combineAuth } from './hr-authority';
import {PersonnelAuthority} from "./personnel-authority";
import { HrCommonAuthority } from './hr-common-authority';

export class EditReadAuthority extends HrCommonAuthority{

    public static readonly EDIT = "edit";
    public static readonly READ = "edit:read";

    constructor(authority: string) {
        super(authority);
        this.EDIT = combineAuth(this.BASE, EditReadAuthority.EDIT);
        this.READ = combineAuth(this.BASE, EditReadAuthority.READ);
    }

    public readonly EDIT: string;
    public readonly READ: string;
}
